/**
 * Mainbeauty — carousel thẻ dùng chung ([data-pi-carousel], dots, kéo được).
 */

// Owl chỉ đo stage khi window resize; box đổi width kiểu khác thì tự refresh (KV dùng lại).
export function piCarouselWatch($el) {
	if (!window.ResizeObserver || !$el.length) {
		return;
	}

	let last = $el[0].offsetWidth;
	new ResizeObserver(function () {
		const now = $el[0].offsetWidth;
		if (now === last) {
			return;
		}
		last = now;
		$el.trigger("refresh.owl.carousel");
	}).observe($el[0]);
}

$(function () {
	$("[data-pi-carousel]").each(function () {
		const el = this;
		const $el = $(el);
		const lg = parseInt($el.data("pi-carousel"), 10) || 3;
		const md = parseInt($el.data("pi-sm"), 10) || Math.min(2, lg);
		const gap = parseInt($el.data("pi-gap"), 10) || 24;
		const autoplay = String($el.data("pi-autoplay")) !== "off";
		const loop = String($el.data("pi-loop")) !== "off";
		const peekOff = String($el.data("pi-peek")) === "off"; // thẻ cao (tier) hiện trọn, không chừa mép
		const arrows = String($el.data("pi-nav")) === "on"; // mũi tên tròn hai bên (desktop), dots vẫn giữ

		const count = $el.children().length;

		// Một thẻ thì không có gì để trượt ở bất kỳ breakpoint nào.
		if (count < 2) {
			$el.removeClass("owl-carousel owl-theme").addClass("pi-carousel--static");
			return;
		}

		// Owl tính gap vào stagePadding, nên cộng thêm gap để lộ đúng dải muốn khoe.
		const peek = function (visible, strip) {
			return count > visible && !peekOff ? gap + strip : 0;
		};

		const start = function () {
			$el.owlCarousel({
				loop: loop,
				margin: gap,
				nav: arrows,
				navText: [
					'<span aria-hidden="true">‹</span><span class="visually-hidden">Trước</span>',
					'<span aria-hidden="true">›</span><span class="visually-hidden">Sau</span>',
				],
				dots: true,
				autoplay: autoplay,
				autoplayTimeout: 5000,
				autoplayHoverPause: true,
				smartSpeed: 550,
				responsive: {
					0: { items: 1, stagePadding: peek(1, 24) },
					768: { items: md, stagePadding: peek(md, 20) },
					992: { items: lg, stagePadding: 0 }, // desktop giữ lưới sạch, dots lo phần gợi ý
				},
			});

			// Slide có form: khách đang gõ thì dừng hẳn, không cho trượt đi mất ô nhập hay thông báo gửi xong.
			if (autoplay) {
				$el.one("focusin", function () {
					$el.trigger("stop.owl.autoplay");
				});
			}

			piCarouselWatch($el);
		};

		// Carousel trong <details> đang đóng đo được 0px — đợi mở lần đầu mới init.
		const panel = el.closest("details");
		if (panel && !panel.open) {
			panel.addEventListener("toggle", function onOpen() {
				if (!panel.open) {
					return;
				}
				panel.removeEventListener("toggle", onOpen);
				start();
			});
			return;
		}

		start();
	});
});
